import { render, staticRenderFns } from "./money-data.vue?vue&type=template&id=3630babc&"
import script from "./money-data.vue?vue&type=script&lang=js&"
export * from "./money-data.vue?vue&type=script&lang=js&"
import style0 from "./money-data.vue?vue&type=style&index=0&id=3630babc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports